import type { FaireProductEntity } from "../../entity_types/product";

export const p_crzctns3aw: FaireProductEntity = {
  token: "p_crzctns3aw",
  type: "product",
  name: "Cape Cod Kettle Cooked Potato Chips - Case of 8 - 5 OZ",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/d7bd3dc07b011dc5a9aaa97781d274e9d889c0694e32ece20bf5eca852ed82e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a8adfa5ab9847980c4507052e4f15300229472a6b8e65f6d5a1781b03eb6a83.jpeg",
    "https://cdn.faire.com/fastly/f2be4dfc0f9c58346d23543d5a08e7827d66d3101f5ae57d3aaf91122f6e5cb3.jpeg",
  ],
  priceDollars: 47.03,
  description:
    "\n\nDiscover the delightful crunch of kettle-cooked perfection with these potato chips. Crafted from carefully selected potatoes, each chip is sliced thick and cooked in custom kettles to achieve a golden amber hue, ensuring a hearty potato flavor in every bite. Made with simple ingredients, these chips contain no artificial colors, flavors, or preservatives and are verified by the Non-GMO Project.\n\n * Non-GMO and made with sea salt \n * Thick-cut for a satisfying crunch \n * Cooked in small batches for quality \n * Perfect for snacking or sharing \n * Available in a convenient case of 8 packs \nWhether you're enjoying a moment alone or sharing with friends, these chips are sure to please with their signature flavor and crunch.\n",
  tags: [],
  msrpDollars: 94.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:38.917Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
